<div class="video-player" *ngIf="youtubeVideoUrl || vimeoVideoUrl">
	<div class="video-contain">
		<youtube-player *ngIf="youtubeVideoUrl" class="iframe-container" [videoId]="youtubeVideoUrl" (ready)="savePlayer($event)"></youtube-player>
		<div *ngIf="vimeoVideoUrl" #playerVimeo class="iframe-container"></div>
	</div>
	<div class="video-player__close icon icon--close" (click)="stopVideo()"></div>
</div>
